import getPosition from "../utils/get-position";

export default class SelectBtn {
	constructor(element) {
		const selectBtn = element;

		if (!selectBtn) {
			return;
		}

		this.adminBar = document.getElementById("wpadminbar");
		this.container = selectBtn.parentElement;
		this.dropdownList = this.container.querySelector("ul");
		this.isExternalList = this.container.classList.contains(
			"has-external-list"
		);

		window.addEventListener("click", e => {
			if (
				e.target === selectBtn ||
				!this.container.classList.contains("active")
			) {
				return;
			}

			this.container.classList.toggle("active");

			if (this.isExternalList) {
				this.dropdownList.classList.toggle("active");
			}
		});

		selectBtn.addEventListener("click", e => {
			e.preventDefault();
			this.toggleDropdown(e);
		});

		selectBtn.addEventListener("keyup", e => {
			if (e.keyCode === 9 && !e.currentTarget.pressed) {
				e.currentTarget.pressed = true;
				e.currentTarget.focus();
				return;
			}

			/*
			 ** Keys that activate dropdown and focus first item on the list: 9: Tab, 13: Enter, 32: Space.
			 ** Use keydown event, keypress event won't capture Tab key press.
			 */
			if (9 === e.keyCode || 13 === e.keyCode || 32 === e.keyCode) {
				this.toggleDropdown(e, this.container, this.dropdownList);
				this.focusFirstItem(this.container);
				e.currentTarget.pressed = false;
			}
		});

		selectBtn.addEventListener("keydown", e => {
			// Prevent Tab Space and Enter key default behaviour
			if (
				(9 === e.keyCode || 13 === e.keyCode || 32 === e.keyCode) &&
				e.currentTarget.pressed
			) {
				e.preventDefault();
			}
		});

		if (this.dropdownList) {
			this.dropdownList.lastElementChild.addEventListener("focusout", e => {
				this.toggleDropdown(e);
			});
		}

		window.addEventListener("resize", () => {
			this.container.classList.remove("active");
			this.container.isPositionCalculated = false;

			if (this.isExternalList) {
				this.setExternalDropdownPosition();
			}
		});
	}

	toggleDropdown(e) {
		e.preventDefault();

		if (!this.container.classList.contains("active") && !this.isExternalList) {
			this.setDropdownPosition(this.dropdownList);
		}

		if (this.isExternalList && !this.dropdownList.isPositionCalculated) {
			this.extractList();
			this.setExternalDropdownPosition();
		}

		this.container.classList.toggle("active");

		if (this.isExternalList) {
			this.dropdownList.classList.toggle("active");
		}
	}

	setDropdownPosition() {
		if (this.container.isPositionCalculated) {
			return;
		}

		const dropdownHeight = this.dropdownList.scrollHeight;
		const elementPositionTop =
			this.container.offsetTop -
			this.container.scrollTop +
			this.dropdownList.clientTop;

		if (dropdownHeight > document.body.scrollHeight - elementPositionTop) {
			this.container.classList.add("is-reverse");
		} else if (this.container.classList.contains("is-reverse")) {
			this.container.classList.remove("is-reverse");
		}

		this.container.isPositionCalculated = true;
	}

	focusFirstItem() {
		this.container.querySelector("ul").addEventListener(
			"transitionend",
			e => {
				e.currentTarget.querySelector("li a").focus();
			},
			{ once: true }
		);
	}

	extractList() {
		document.body.appendChild(this.dropdownList);
		this.dropdownList.classList.add("external-dropdown-list");
	}

	setExternalDropdownPosition() {
		const containerPosition = getPosition(this.container);
		const adminBarH = this.adminBar ? this.adminBar.offsetHeight : 0;
		const offsetLeft = this.container.offsetWidth / 2 + containerPosition.x;
		const offsetTop =
			this.container.offsetHeight + containerPosition.y + adminBarH;

		this.dropdownList.style.top = `${offsetTop}px`;
		this.dropdownList.style.left = `${offsetLeft}px`;
		this.dropdownList.isPositionCalculated = true;
	}
}
